import { useMemo, useCallback } from 'react';
import find from 'lodash/find';
export var useGridActionTrigger = function (rowsData, uxState, actionOptions, onBatchAction) {
    if (actionOptions === void 0) { actionOptions = []; }
    var actionRows = useMemo(function () {
        return (rowsData || []).filter(function (row) { var _a; return (_a = uxState.checkedRows) === null || _a === void 0 ? void 0 : _a[row.id]; });
    }, [uxState, rowsData]);
    var enabledActions = useMemo(function () {
        var actionsOptions = actionOptions || [];
        return actionsOptions.filter(function (action) {
            if (action.isEnabled) {
                return action.isEnabled(actionRows);
            }
            else {
                return uxState.checkedRows && find(uxState.checkedRows, Boolean);
            }
        });
    }, [uxState, actionRows, actionOptions]);
    var handleBatchAction = useCallback(function (value) {
        var actionsOptions = actionOptions || [];
        var action = actionsOptions.find(function (option) { return option.value == value; });
        action && onBatchAction && onBatchAction(action, actionRows);
    }, [actionOptions, onBatchAction, actionRows]);
    return [enabledActions, handleBatchAction];
};
